import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Logo from '@/components/Logo';

const PaymentCancelled = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/plan-selection');
  };

  const handleContactSupport = () => {
    window.location.href = 'mailto:support@dineai.ai?subject=Payment%20Issue';
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1f4ed1] to-[#2256e5]">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <Logo className="text-white h-10" />
          </div>

          {/* Cancelled Card */}
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center">
                <XCircle className="w-12 h-12 text-red-400" />
              </div>
            </div>

            <h1 className="text-3xl font-bold text-white mb-4">
              Payment Cancelled
            </h1>

            <p className="text-xl text-white/80 mb-8">
              Your payment was cancelled. No charges were made to your card.
            </p>

            <div className="bg-white/5 rounded-lg p-6 mb-8">
              <p className="text-white/70 mb-4">
                Don't worry! You can still start your free trial anytime.
              </p>
              <ul className="text-left text-white/60 space-y-2 text-sm">
                <li>• 30-day free trial - no charge today</li>
                <li>• Cancel anytime during the trial</li>
                <li>• Full access to all features</li>
                <li>• No hidden fees</li>
              </ul>
            </div>

            <div className="space-y-4">
              <Button
                onClick={handleGoBack}
                className="w-full py-6 text-lg bg-[#FDB913] hover:bg-[#FDB913]/90 text-black font-semibold flex items-center justify-center gap-2"
              >
                <ArrowLeft className="w-5 h-5" />
                Back to Plans
              </Button>

              <Button
                onClick={handleContactSupport}
                variant="ghost"
                className="w-full text-white/70 hover:text-white"
              >
                Having issues? Contact Support
              </Button>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 text-center text-white/60 text-sm">
            <p>Questions about pricing? Email us at support@dineai.ai</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;